import { render, staticRenderFns } from "./marketBlacklistManageList.vue?vue&type=template&id=ed3c5834&scoped=true"
import script from "./marketBlacklistManageList.vue?vue&type=script&lang=js"
export * from "./marketBlacklistManageList.vue?vue&type=script&lang=js"
import style0 from "./marketBlacklistManageList.vue?vue&type=style&index=0&id=ed3c5834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3c5834",
  null
  
)

export default component.exports